import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { forgotPswThunk } from "../../asyncThunks/auth";

const initialState: defaultState = {
  error: null,
  data: null,
  loading: false,
};

export const forgotPassword = createSlice({
  name: "forgotpsw",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(forgotPswThunk.pending, (state, action) => {
      state.error = null;
      state.data = null;
      state.loading = true;
    });
    builder.addCase(forgotPswThunk.fulfilled, (state, action) => {
      if (action?.payload?.status?.toLowerCase() === "success") {
        state.error = null;
        state.data = action.payload;
      } else {
        state.error = action?.payload;
        state.data = null;
      }
      state.loading = false;
    });
    builder.addCase(forgotPswThunk.rejected, (state, action) => {
      state.error = action.payload;
      state.data = null;
      state.loading = false;
    });
  },
});

export default forgotPassword.reducer;
